import React, { useState } from 'react';
import { Form, FloatingLabel, InputGroup, Container, Row, Col } from 'react-bootstrap';
import Button from '@mui/material/Button';
import { AxiosInstance } from '../baseUrl';
import Swal from 'sweetalert2';

const AuthComponent = ({ onLogin }) => {
    const [login, setLogin]       = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading]   = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await AxiosInstance.post('/auth/login', { login, password });
            const checkRes = await AxiosInstance.get('/auth/check');
            Swal.fire({
                title: 'Привіт!',
                text: 'Ласкаво просимо назад',
                icon: 'success',
                timer: 1800,
                showConfirmButton: false,
                background: '#1a1a1a',
                color: '#e8e8e8',
            });
            onLogin(checkRes.data);
        } catch (err) {
            const detail = err?.response?.data?.detail;
            Swal.fire({
                icon: 'error',
                title: 'Помилка входу',
                text: detail || 'Невірний логін або пароль',
                background: '#1a1a1a',
                color: '#e8e8e8',
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container
            fluid
            style={{
                minHeight: '100vh',
                background: '#0f0f0f',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Row style={{ width: '100%', maxWidth: 420 }}>
                <Col>
                    <h2 style={{ color: '#e8e8e8', marginBottom: 32, textAlign: 'center', fontWeight: 700 }}>
                        Lesson Notebook
                    </h2>
                    <Form onSubmit={handleLogin}>
                        <InputGroup className="mb-3">
                            <InputGroup.Text style={{ background: '#1a1a1a', border: '1px solid #2e2e2e', color: '#888' }}>
                                👤
                            </InputGroup.Text>
                            <FloatingLabel controlId="login" label="Логін" style={{ flex: 1 }}>
                                <Form.Control
                                    type="text"
                                    placeholder="login"
                                    value={login}
                                    onChange={e => setLogin(e.target.value)}
                                    style={{ background: '#1a1a1a', border: '1px solid #2e2e2e', color: '#e8e8e8' }}
                                />
                            </FloatingLabel>
                        </InputGroup>

                        <InputGroup className="mb-4">
                            <InputGroup.Text style={{ background: '#1a1a1a', border: '1px solid #2e2e2e', color: '#888' }}>
                                🔒
                            </InputGroup.Text>
                            <FloatingLabel controlId="password" label="Пароль" style={{ flex: 1 }}>
                                <Form.Control
                                    type="password"
                                    placeholder="password"
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                    style={{ background: '#1a1a1a', border: '1px solid #2e2e2e', color: '#e8e8e8' }}
                                />
                            </FloatingLabel>
                        </InputGroup>

                        <Button
                            type="submit"
                            variant="contained"
                            fullWidth
                            disabled={loading}
                            style={{ background: '#5865f2', padding: '12px', borderRadius: 8 }}
                        >
                            {loading ? 'Вхід...' : 'Увійти'}
                        </Button>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
};

export default AuthComponent;
